import { WarningOctagon, UserMinus, ArrowLeft } from "@phosphor-icons/react";
import type { CustomerDetailLabels } from "./types";

interface Props {
  variant: "error" | "not-found";
  labels: CustomerDetailLabels;
  onRetry?: () => void;
  onBack?: () => void;
  message?: string;
}

export function CustomerDetailErrorState({ variant, labels, onRetry, onBack, message }: Props) {
  const isNotFound = variant === "not-found";
  const IconCmp = isNotFound ? UserMinus : WarningOctagon;
  return (
    <div className="h-full flex items-center justify-center p-8 bg-biz-bg">
      <div className="max-w-md w-full rounded-biz-card border border-biz-border bg-biz-surface p-8 text-center shadow-biz-sm">
        <div className="mx-auto h-14 w-14 rounded-full bg-biz-danger-subtle text-biz-danger flex items-center justify-center">
          <IconCmp size={24} weight="regular" />
        </div>
        <h2 className="mt-4 text-lg font-display font-bold text-biz-foreground">
          {isNotFound ? labels.states.notFoundTitle : labels.states.errorTitle}
        </h2>
        <p className="mt-1 text-sm text-biz-foreground-muted">
          {message ?? (isNotFound ? labels.states.notFoundBody : "")}
        </p>
        <div className="mt-5 flex items-center justify-center gap-2">
          {onBack && (
            <button
              type="button"
              onClick={onBack}
              className="h-11 px-4 rounded-biz-btn border border-biz-border text-sm font-semibold text-biz-foreground-muted hover:bg-biz-muted inline-flex items-center gap-1.5 biz-focus-ring transition-colors"
            >
              <ArrowLeft size={16} weight="regular" />
              {labels.backToList}
            </button>
          )}
          {!isNotFound && onRetry && (
            <button
              type="button"
              onClick={onRetry}
              className="h-11 px-4 rounded-biz-btn bg-biz-primary text-biz-primary-foreground hover:bg-biz-primary-hover text-sm font-semibold biz-focus-ring transition-colors"
            >
              {labels.states.errorRetry}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
